<template>
  <div class="row">
    <div class="w-100">
      <!-- nav bar -->
      <b-navbar toggleable type="light" variant="" class="lst-order-title">
        <!-- brand -->
        <b-navbar-brand>
          <div style="display: flex; align-items: center;">
            <i class="rs-icon-default rs-icon-logo"></i>
            <span style="color: #ced4da; padding-left: 13px;">功能列表</span>
          </div>
        </b-navbar-brand>
      </b-navbar>

      <!-- list -->
       <div class="cs__menu-box">
        <div
          class="cs__menu-item"
          v-for="(item, index) in menuItems"
          :key="index"
          @click="to(item.value)"
        >
          {{ item.label }}
        </div>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StaffMenu',
  data () {
    return {
      menuItems: [
        { label: '個人資料', value: '/' },
        { label: '訂單清單', value: '/' },
        { label: '服務履歷清單', value: '/staff/service_records' }
      ]
    }
  },
  methods: {
    to (value) {
      this.$router.push({ path: value })
    }
  }
}
</script>
